import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { eventList } from "Apis/event";

export const EventBookingContext = createContext();

export const EventBookingContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [eventbookingData, setEventBookingData] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [upcomingEventData, setUpcomingEventData] = useState([]);

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  // Json Listing
  const getEventList = async () => {
    const response = await eventList();
    const event = response?.data?.data?.rows?.map((data) => ({
      label: data?.title,
      value: data?.id,
      total_amount: data?.booking_amount,
      member_only: data?.member_only,
      is_allow_guest_booking: data?.is_allow_guest_booking,
      guest_price: data?.guest_price,
    }));
    setEventData(event);
  };

  // Json Listing
  const getUpcomingEventList = async () => {
    const response = await eventList({
      filters: { upcoming: "true" },
    });
    const event = response?.data?.data?.rows?.map((data) => ({
      label: data?.title,
      value: data?.id,
      total_amount: data?.booking_amount,
      member_only: data?.member_only,
      is_allow_guest_booking: data?.is_allow_guest_booking,
      guest_price: data?.guest_price,
    }));
    setUpcomingEventData(event);
  };

  return (
    <EventBookingContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        eventbookingData,
        setEventBookingData,
        eventData,
        getEventList,
        upcomingEventData,
        setUpcomingEventData,
        getUpcomingEventList,
      }}
    >
      {children}
    </EventBookingContext.Provider>
  );
};

export default EventBookingContextProvider;
EventBookingContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
